import React, { useState, useEffect, useRef } from 'react';
import ChevronDown from '../../icons/ChevronDown';
import './PriceCalculator.css';
import { useTranslation } from 'react-i18next';
import SendConfirmation from '../../pages/contact/SendConfirmation';

function PriceCalculator() {
    const [locationType, setLocationType] = useState('Hotel');
    const [totalRooms, setTotalRooms] = useState(0);
    const [email, setEmail] = useState('');
    const [modulesType, setModulesType] = useState([]);
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);
    const { t } = useTranslation();
    const [isSent, setIsSent] = useState(false);

    const locationTypeOptions = [t("Hotel"), t("Hostel"), t("Resort"), t("Vacation Rental")];
    const [inventoryItems, setInventoryItems] = useState([
        { label: "Property Management System", selected: false },
        { label: "Channel Manager", selected: false },
        { label: "Booking Engine", selected: false },
        { label: "Point of Sale", selected: false },
        { label: "Prostay Nexus", selected: false }
      ]);

    const inventoryItemRef = useRef(null);

    const handleDropdownToggle = (event) => {
        event.stopPropagation();
        setIsDropdownOpen(prev => !prev);
    };
    
    
      const handleInventoryChange = (index) => {
        const newItems = [...inventoryItems];
        newItems[index].selected = !newItems[index].selected;
        setInventoryItems(newItems);
    };
    
    

    const handleDecrease = () => {
        setTotalRooms(prev => (prev > 0 ? prev - 1 : 0));
    };

    const handleIncrement = () => {
        setTotalRooms(prev => prev + 1);
    };

    const handleInputChange = (e) => {
        const value = e.target.value;
        if (value === '' || /^\d+$/.test(value)) {
            setTotalRooms(value === '' ? 0 : Math.max(1, parseInt(value)));
        }
    };
    
    const pricingData = {
        "Hotel": {
            baseFee: 99,
            pricePerRoom: [
                { min: 1, max: 10, price: 11 },
                { min: 11, max: 50, price: 9 },
                { min: 51, max: Infinity, price: 7 }
            ]
        },
        "Resort": {
            baseFee: 149,
            pricePerRoom: [
                { min: 1, max: 10, price: 12 },
                { min: 11, max: 50, price: 10 },
                { min: 51, max: Infinity, price: 8 }
            ]
        },
        "Vacation Rental": {
            baseFee: 79,
            pricePerRoom: [
                { min: 1, max: 10, price: 8 },
                { min: 11, max: 50, price: 6 },
                { min: 51, max: Infinity, price: 5 }
            ]
        }
    };

    const getPricePerRoom = () => {
        if (totalRooms === 0) return 0;
        const selectedPricing = pricingData[locationType].pricePerRoom;
        const priceRange = selectedPricing.find(range => totalRooms >= range.min && totalRooms <= range.max);
        return priceRange ? priceRange.price : 0; 
    };
    
    const calculatePrice = () => {
        const baseFee = pricingData[locationType].baseFee;
        const pricePerRoom = getPricePerRoom();
        return baseFee + (pricePerRoom * totalRooms);
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        setIsSent(true);

    };

    useEffect(() => {
        function handleClickOutside(event) {
            if (inventoryItemRef.current && !inventoryItemRef.current.contains(event.target)) {
                setTimeout(() => setIsDropdownOpen(false), 100);
            }
        }
    
        document.addEventListener("click", handleClickOutside);
        return () => {
            document.removeEventListener("click", handleClickOutside);
        };
    }, []);
    
    
    return (
        <div className={`d-flex justify-content-center price-calculator ${isSent ? "sent" : ""}`}>
            {isSent ? (
            <SendConfirmation/> ) : 
            (
            <div className='page-content'>
                <div className='col-6 card-content'>
                    <h2>{t('Find Your Perfect Hotel Software Price Plan Here - For Any Budget')}</h2>
                    <div className='d-flex inputs-row mt-4'>
                        <div className='flex-column d-flex col-8 custom-50-width'>
                            <label className='label-xsmall'>{t('I own')}</label>
                            <div className='select-container w-100' style={{ position: 'relative' }}>
                                <select value={locationType} onChange={(e) => setLocationType(e.target.value)}>
                                    {
                                        locationTypeOptions.map(type =>
                                            <option value={type}>{type}</option>
                                        )
                                    }
                                </select>
                                <svg width="14" height="9" viewBox="0 0 14 9" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ position: 'absolute', right: 20, top: 22 }}>
                                    <path d="M1 1.5L7 7.5L13 1.5" stroke="#808698" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                </svg>
                            </div>
                        </div>
                        <div className='flex-column d-flex col'>
                            <label className='label-xsmall'>{t('Total Rooms')}</label>
                            <div className='custom-number-input w-100'>
                                <button style={{ border: 'none', backgroundColor: 'transparent' }} onClick={handleDecrease}>
                                    <svg width="12" height="3" viewBox="0 0 12 3" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M0.5 1.50005C0.5 1.3144 0.57375 1.13635 0.705025 1.00507C0.836301 0.873799 1.01435 0.800049 1.2 0.800049H10.8C10.9857 0.800049 11.1637 0.873799 11.295 1.00507L11.645 0.655061L11.295 1.00507C11.4263 1.13635 11.5 1.3144 11.5 1.50005C11.5 1.6857 11.4263 1.86375 11.295 1.99502C11.1637 2.1263 10.9857 2.20005 10.8 2.20005H1.2C1.01435 2.20005 0.836301 2.1263 0.705026 1.99502L0.351472 2.34858L0.705025 1.99502C0.57375 1.86375 0.5 1.6857 0.5 1.50005Z" fill="#18181B" stroke="#1643E0" />
                                    </svg>
                                </button>
                                <input
                                    className='input-noborder'
                                    type="text"
                                    value={totalRooms}
                                    onChange={handleInputChange}
                                    style={{ textAlign: 'center', width: '50px' }}
                                />
                                <button style={{ border: 'none', backgroundColor: 'transparent' }} onClick={handleIncrement}>
                                    <svg width="14" height="15" viewBox="0 0 14 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M7 1.5V7.5M7 7.5V13.5M7 7.5H13M7 7.5H1" stroke="#1643E0" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                    </svg>
                                </button>
                            </div>
                        </div>
                    </div>
                    <div className='flex-column d-flex email-container' style={{position:"relative"}}>
                        <label className='label-xsmall'>{t('Modules')}</label>
                        <div onClick={handleDropdownToggle} className='custom-input'>
                            <span className='multi-select-txt'>
                            {inventoryItems.every(item => item.selected) 
                                ? t('All items') 
                                : inventoryItems.filter(item => item.selected).map(item => item.label).join(', ') || t('Nothing selected')}
                            </span>
                        </div>
                        <svg width="14" height="9" viewBox="0 0 14 9" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ position: 'absolute', right: 20, top: 40 }}>
                            <path d="M1 1.5L7 7.5L13 1.5" stroke="#808698" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                        {isDropdownOpen && (
                            <div className="custom-menu" ref={inventoryItemRef}>
                            {inventoryItems.map((item, index) => (
                                <div key={index} style={{cursor:'pointer'}} className="d-flex align-items-center menu-option" onClick={() => handleInventoryChange(index)}>
                                <input style={{width:"15px", height:'10px', cursor: 'pointer'}}
                                    type="checkbox"
                                    checked={item.selected}
                                />
                                <div className='multi-select-txt'>{item.label}</div>
                                </div>
                            ))}
                            </div>
                        )}
                    </div>
                    <div className='flex-column d-flex email-container'>
                        <label className='label-xsmall'>{t('E-Mail')}</label>
                        <input value={email} onChange={(e) => setEmail(e.target.value)} />
                    </div>
                    {/*
                    <div className={`price-card ${totalRooms > 0 ? "show" : ""}`}>
                        <div className='col'>
                            <span className='title'>{t('Starting Price')}</span>
                            <p className='body-large'>{t('Best price for business')}</p>
                        </div>
                        <div className='col-auto d-flex align-items-baseline justify-content-end'>
                            <h1>${calculatePrice()}</h1>
                            <small>{t('/Month')}</small>
                        </div>
                    </div> */}
                    <button className='light-blue-filled-btn-medium d-flex align-items-center gap-2 mt-4' onClick={handleSubmit}>
                        {t('Contact Sales')}
                        <svg width="16" height="12" viewBox="0 0 20 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M19 8H1H19Z" fill="white" />
                            <path d="M12 1L19 8M19 8L12 15M19 8H1" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                    </button>
                    <div className='mt-4 body-small' style={{ color: '#606576', fontSize: 14, fontFamily: 'Inter' }}>
                        {t('Our pricing is customized to fit your operational needs. It reflects the size of your property and the modules included in your Prostay setup.')}
                    </div>
                </div>
                <div className='col-5 center-img'>
                    <img src='/images/accounting.png' style={{maxWidth: '100%'}} alt={"Accounting manager"}/>
                </div>
            </div>
            )}
        </div>
    );
}

export default PriceCalculator;
